import translations from '../lang';
import { SSO_URLS } from '../constants/config';
import { ROUTES } from './routes';

const { SESSION } = translations['en-US'];

const envKey =
  process.env.REACT_APP_IS_LOCAL === 'true'
    ? 'localhost'
    : process.env.REACT_APP_API_ENV;

const PUBLIC_PATH_PREFIXES = [
  ROUTES.LOGIN,
  '/registration',
  '/forgot-password',
  '/reset-password',
  '/error',
  '/invitation-expired',
  ROUTES.TRIAL,
  '/logout',
];

export const accountsSsoConfig = {
  appID: 'home',
  idServerBase: SSO_URLS[envKey].REACT_APP_ID_SERVER_BASE,
  idServerBaseSignIn: SSO_URLS[envKey].REACT_APP_ID_SERVER_AUTH,
  apiEnv: process.env.REACT_APP_API_ENV,
  isExternalPath: () =>
    PUBLIC_PATH_PREFIXES.some((path) =>
      window.location.pathname.startsWith(path)
    ),
  sessionLockCopy: {
    title: SESSION.TITLE,
    message: SESSION.MESSAGE,
    logoutLabel: SESSION.LOGOUT,
  },
};
